import React, { useRef, useEffect } from 'react';
import { cn } from '../../lib/utils';

export function DropdownMenu({ children }) {
  return <div className="dropdown-menu">{children}</div>;
}

export function DropdownMenuTrigger({ children, asChild, onClick }) {
  if (asChild) {
    if (!React.isValidElement(children)) {
      throw new Error('DropdownMenuTrigger with asChild requires a single React element as children');
    }
    const childOnClick = children.props.onClick;
    return React.cloneElement(children, {
      onClick: (e) => {
        if (childOnClick) childOnClick(e);
        if (onClick) onClick(e);
      },
    });
  }
  return <div onClick={onClick}>{children}</div>;
}

export function DropdownMenuContent({ children, open, onClose, align = 'start', className }) {
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;

    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        onClose();
      }
    };

    const handleEscape = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleEscape);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEscape);
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      ref={ref}
      className={cn(
        'dropdown-content',
        align === 'end' ? 'right-0' : 'left-0',
        className
      )}
    >
      {children}
    </div>
  );
}

export function DropdownMenuItem({ children, onClick, className }) {
  return (
    <div
      className={cn('dropdown-item', className)}
      onClick={onClick}
    >
      {children}
    </div>
  );
}

export function DropdownMenuSeparator() {
  return <div className="dropdown-separator" />;
}
